// services/NewsletterService.ts
import { authCall } from '.'
import { subscribeNewsletter, unsubscribeNewsletter } from './endpoints'
import {
  SubscribeNewsletterRequest,
  SubscribeNewsletterResponse,
  UnsubscribeNewsletterResponse,
} from '../interfaces/newsletter'

const NewsletterService = {
  subscribe: (data: SubscribeNewsletterRequest) => {
    return authCall<SubscribeNewsletterResponse>({
      url: subscribeNewsletter,
      method: 'post',
      data,
    })
  },

  unsubscribe: (ids: string[]) => {
    return authCall<UnsubscribeNewsletterResponse>({
      url: `${unsubscribeNewsletter}?ids=${ids.join(',')}`,
      method: 'delete',
    })
  },
}

export default NewsletterService
